// extracted by mini-css-extract-plugin
export default {"edit-section-navigation-root":"EditSectionNavigation_edit-section-navigation-root__vH9fG","item":"EditSectionNavigation_item__6uMXR","active":"EditSectionNavigation_active__175cZ"};